module.exports = __webpack_public_path__ + "media/images/logo-b6712d585355df60c4735b6700b18d2d.svg";